
import { Grid, Link, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import KeyInformationDetailItem from 'libs/feature-loan-details/src/loanDetails/components/key-information-collapse/key-information-detail-item';
import { isNotBlank } from '@roc/feature-utils';
import { APPRAISAL_REPORT, CONSTRUCTION_FEASIBILITY_REVIEW, DocumentForms, PERMITS, useDocumentStore } from '@roc/feature-documents';
import { Document } from '@roc/feature-types';
import { PDFPreview } from '@roc/ui';
import { formatNumberWithCommas } from '@roc/ui/utils';

const useStyles = makeStyles(theme => ({
  formContainer: {
    marginTop: -40,
  },
  title: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '157%',
    letterSpacing: '0.1px',
    color: '#333333',
  },
  border: {
    borderRight: '1px solid #E1E1E1',
  },
}));

export const ViewPropertyDetails = observer(({ loanId, property }: { loanId: string; property: any; }) => {

  const classes = useStyles();
  const { documentStore } = useDocumentStore();

  const propertyInformation = [
    {
      label: 'Bedrooms',
      value: isNotBlank(property?.bedrooms) ? property?.bedrooms : '-',
    },
    {
      label: 'Bathrooms',
      value: isNotBlank(property?.bathrooms) ? property?.bathrooms : '-',
    },
    {
      label: 'Gross Leasable Area',
      value: isNotBlank(property?.grossLeasableRentableArea) ? formatNumberWithCommas(property?.grossLeasableRentableArea) : '-',
    },
    {
      label: 'Number of Units',
      value: isNotBlank(property?.units) ? property?.units : '-',
    },
    {
      label: 'Stories',
      value: isNotBlank(property?.stories) ? property?.stories : '-',
    },
    {
      label: 'Foundation',
      value: isNotBlank(property?.foundation) ? property?.foundation : '-',
    },
    {
      label: 'Special Project Type',
      value: isNotBlank(property?.describeRenovation) ? property?.describeRenovation : '-',
    },
    {
      label: 'Insurance Expiry Date',
      value: isNotBlank(property?.insuranceExpiryDate) ? property?.insuranceExpiryDate : '-',
    },
  ];

  const openAppraisal = () => {
    documentStore.getPropertyLoanDocument(parseInt(loanId), APPRAISAL_REPORT, property.propertyId).then((response) => {
      const loanTask: Document = response;
      documentStore.previewDocument(loanTask);
    }).catch((err) => {
      console.log(err);
    });
  }

  const openConstructionFeasibilityReport = () => {
    documentStore.getPropertyLoanDocument(parseInt(loanId), CONSTRUCTION_FEASIBILITY_REVIEW, property.propertyId).then((response) => {
      const loanTask: Document = response;
      documentStore.onOpenForm(loanTask);
    }).catch((err) => {
      console.log(err);
    });
  }

  const openCollateralPage = () => {
    const msg = { action: 'openCollateralPage', propertyId: property?.propertyId };
    window.parent.postMessage(msg, '*');
  }

  // const openPlans = () => {
  //   documentStore.getPropertyLoanDocument(parseInt(loanId), PLANS, property.propertyId).then((response) => {
  //     const loanTask: Document = response;
  //     documentStore.previewDocument(loanTask);
  //   }).catch((err) => {
  //     console.log(err);
  //   });
  // }

  // const openPermits= () => {
  //   documentStore.getPropertyLoanDocument(parseInt(loanId), PERMITS, property.propertyId).then((response) => {
  //     const loanTask: Document = response;
  //     documentStore.previewDocument(loanTask);
  //   }).catch((err) => {
  //     console.log(err);
  //   });
  // }

  return (
    <>
      <Grid className={classes.formContainer} container direction='row' spacing={2}>
        <Grid item xs={12} md={6} className={classes.border}>
          <KeyInformationDetailItem title='Property Information' items={propertyInformation} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container direction='column' spacing={2}>
            <Grid item>
              <Typography variant='h5' component='h5' className={classes.title}>
                Links
              </Typography>
            </Grid>
            <Grid item container direction='column' spacing={1}>
              <Grid item>
                <Link style={{ textDecoration: 'underline' }} onClick={() => openAppraisal()}>
                  Appraisal
                </Link>
              </Grid>
              <Grid item>
                <Link style={{ textDecoration: 'underline' }} onClick={() => openConstructionFeasibilityReport()}>
                  Construction Feasibility Report
                </Link>
              </Grid>
              <Grid item>
                <Link style={{ textDecoration: 'underline' }} onClick={() => openCollateralPage()}>
                  Collateral Page
                </Link>
              </Grid>
              {/* <Grid item>
                <Link style={{ textDecoration: 'underline' }} onClick={() => openPlans()}>
                  Plans
                </Link>
              </Grid>
              <Grid item>
                <Link style={{ textDecoration: 'underline' }} onClick={() => openPermits()}>
                  Permits
                </Link>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <DocumentForms loanId={loanId} />
      <PDFPreview
        open={documentStore.documentPreview != null}
        title={documentStore.documentPreview?.title}
        data={documentStore.documentPreview?.data}
        dataV2={documentStore.documentPreview?.data}
        headers={documentStore.documentPreview?.headers}
        onClose={() => documentStore.closeDocumentPreview()}
      />
    </>
  );
}
);

export default ViewPropertyDetails;
